<button *ngIf="!isSendingRequest" mat-flat-button [color]="color" type="submit" [id]="id" [disabled]="disabled" (click)="onClick()">{{textKey | translate}}</button>
<mat-spinner diameter="36" *ngIf="isSendingRequest"></mat-spinner>
